// extracted by mini-css-extract-plugin
module.exports = {"label":"PlainInput_label__-Sgpx","input":"PlainInput_input__mVqj_"};